<!-- 编辑采购询价单 -->
<template>
    <div class="business-content-main supplier-req-edit" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <div class="section-title" @click="showMsg">
                <div>
                    <span>订单信息 {{submitData.InquiryCode?'【'+submitData.InquiryCode+'】':''}}</span>
                    <span v-show="!showOrderMsg && submitData.EntpCusName">&nbsp;&nbsp;&nbsp;&nbsp;供应商：{{ submitData.EntpCusName }}</span>
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="addCustomer(1)" v-if="permission.addSupplier && type != 1">新增供应商</el-button>
                    <el-button size="small" class="search-btn btn-primary" @click="addCustomer(2)" v-if="submitData.EntpCusId && permission.editSupplier && type != 1"
                        >编辑供应商</el-button
                    >
                </div>
            </div>
            <div class="open-icon" @click="showMsg" v-show="!showOrderMsg">
                <img src="../../../assets/images/open-msg.png" />
            </div>
            <div class="inquiry-order-infoes" v-show="showOrderMsg">
                <el-form ref="form" label-width="95px" style="width: 100%; padding-right: 10px; padding-left: 10px" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="选择供应商" prop="EntpCusId">
                                    <el-select
                                        style="width: 100%"
                                        size="small"
                                        :disabled="type == 1"
                                        v-model="submitData.EntpCusId"
                                        filterable
                                        clearable
                                        remote
                                        :remote-method="searchCustomer"
                                        v-select-scroll-more="searchSupplierLoad"
                                        @change="customerChange($event)"
                                        @visible-change="customerVisibleChange($event)"
                                        reserve-keyword
                                        placeholder="选择供应商"
                                    >
                                        <el-option
                                            v-for="optionItem in customerList"
                                            :key="optionItem.EntpCusId"
                                            :data-msg="optionItem"
                                            :label="optionItem.EntpCusName"
                                            :value="optionItem.EntpCusId"
                                        ></el-option> </el-select
                                ></el-form-item></div
                        ></el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="入仓仓库" prop="WarehouseId" style="width: 100%">
                                    <el-input
                                        size="small"
                                        v-if="type == 1"
                                        :title="submitData.WarehouseName"
                                        v-model="submitData.WarehouseName"
                                        style="width: 100%"
                                        :disabled="true"
                                    ></el-input>
                                    <el-select
                                        v-else
                                        size="small"
                                        style="width: 100%"
                                        v-model="submitData.WarehouseId"
                                        placeholder="请选择"
                                        filterable
                                        clearable
                                        @visible-change="warehouseVisibleChange($event)"
                                        @change="warehouseChange"
                                    >
                                        <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId">
                                            <span style="float: left">{{ item.WarehouseName }}</span>
                                            <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div></el-col
                        >
                        <el-col :span="6"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="运费">
                                    <el-input
                                        min="0"
                                        size="small"
                                        type="number"
                                        step="0.01"
                                        style="width: 100%"
                                        :disabled="type == 1"
                                        v-model.trim="submitData.PriceSumShip"
                                    ></el-input>
                                </el-form-item></div
                        ></el-col>
                        <el-col :span="6"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="询价日期">
                                    <el-date-picker
                                        size="small"
                                        style="width: 100%"
                                        :disabled="type == 1"
                                        value-format="yyyy-MM-dd"
                                        v-model="submitData.QTime"
                                        type="date"
                                    ></el-date-picker>
                                </el-form-item></div
                        ></el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="期限日期">
                                    <el-date-picker
                                        size="small"
                                        style="width: 100%"
                                        :disabled="type == 1"
                                        value-format="yyyy-MM-dd"
                                        v-model="submitData.NeedTime"
                                        type="date"
                                    ></el-date-picker>
                                </el-form-item></div
                        ></el-col>
                        <el-col :span="6"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="报价日期">
                                    <el-date-picker
                                        size="small"
                                        style="width: 100%"
                                        :disabled="type == 1"
                                        value-format="yyyy-MM-dd"
                                        v-model="submitData.ITime"
                                        type="date"
                                    ></el-date-picker>
                                </el-form-item></div
                        ></el-col>
                        <el-col :span="12"
                            ><div class="grid-content bg-purple">
                                <el-form-item label="备注">
                                    <el-input size="small" :disabled="type == 1" style="width: 100%" v-model.trim="submitData.Remark"></el-input>
                                </el-form-item></div
                        ></el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="section-title" @click="hideMsg()">
                <div>商品明细</div>
                <div>
                    <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="type != 1 && permission.searchAP">搜索配件(F2)</el-button>
                </div>
            </div>
        </div>
        <!-- table body -->
        <div id="infinite-list" :style="{ height: infiniteListHeight + 'px' }" @click="hideMsg()">
            <ux-grid
                ref="infiniteTable"
                :data="dataList"
                keep-source
                :height="infiniteTableHeight"
                :checkboxConfig="{ highlight: false }"
                :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle"
                highlight-current-row
                show-summary
                :summary-method="setSummaries"
            >
                <ux-table-column class-name="table-sort" type="index" title="序号" width="50"></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['sales-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle('sapcode')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="sapcode"
                            style="width: 100%"
                            :allow-create="isCheckCode"
                            default-first-option
                            size="small"
                            v-model="scope.row.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, scope.rowIndex)"
                            @visible-change="apCodeVisibleChange($event)"
                            :remote-method="searchCode"
                            v-select-scroll-more="searchCodeLoad"
                            @keyup.enter.native="keyEvent($event, 'APCode')"
                            @keyup.right.native="keyEvent($event, 'APCode')"
                            :disabled="type == 1 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="isCheckCode? optionItem.APCode: optionItem.EntpTempGoodsId"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodName" title="配件名称" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle('partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            v-if="scope.row.IsNew"
                            size="small"
                            placeholder="配件名称"
                            v-model="scope.row.GoodName"
                            :disabled="type == 1 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                        />
                        <el-select
                            v-else
                            ref="partsNameSelect"
                            style="width: 100%"
                            allow-create
                            size="small"
                            v-model="scope.row.GoodName"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @change="nameChange($event, scope.rowIndex)"
                            @visible-change="apNameVisibleChange($event)"
                            :remote-method="searchName"
                            v-select-scroll-more="searchNameLoad"
                            @keyup.enter.native="keyEvent($event, 'GoodName')"
                            @keyup.right.native="keyEvent($event, 'GoodName')"
                            @keyup.left.native="keyEvent($event, 'GoodName')"
                            :disabled="type == 1 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in nameList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.GoodName"
                                :value="optionItem.GoodName"
                            >
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <el-tooltip effect="dark" :content="row.AutoSerise" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle('autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            size="small"
                            v-model="scope.row.AutoSerise"
                            placeholder="车系"
                            v-if="scope.row.IsNew"
                            :disabled="type == 1 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                        ></el-input>
                        <el-select
                            v-else
                            ref="autoSeriseSelect"
                            style="width: 100%"
                            allow-create
                            size="small"
                            v-model="scope.row.AutoSerise"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="车系"
                            :remote-method="searchAutoSerie"
                            v-select-scroll-more="searchAutoSerieLoad"
                            @visible-change="autoSerieVisibleChange($event)"
                            popper-class="el-select-style-gray"
                            @keyup.enter.native="keyEvent($event, 'AutoSerise')"
                            @keyup.right.native="keyEvent($event, 'AutoSerise')"
                            @keyup.left.native="keyEvent($event, 'AutoSerise')"
                            :disabled="type == 1 || (scope.row.hasLock && lastRowIndex !== scope.rowIndex)"
                        >
                            <el-option :loading="true" v-for="item in seriesList" :key="item.SeriesId" :label="item.SeriesName" :value="item.SeriesName">
                                <div class="option-content">
                                    <div class="project-Name">{{ item.SeriesName }}</div>
                                    <div class="project-Name">{{ item.GoodName }}</div>
                                    <div class="project-Name">{{ item.APCode }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ item.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ item.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" v-if="isShowBrand" width="90" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>                  
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="160" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle('originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            ref="originRef"
                            size="small"
                            v-model="scope.row.Origin"
                            @keyup.right.native="keyEvent($event, 'Origin')"
                            @keyup.left.native="keyEvent($event, 'Origin')"
                            @focus="selectAutoHandle('originRef')"
                            :disabled="type == 1"
                        ></el-input>
                    </template>
                </ux-table-column>  
                <ux-table-column field="Size" title="规格" v-if="isSizeShow" width="160" resizable key="Size">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Size }}</div>
                    </template>
                </ux-table-column>                     
                <ux-table-column field="Count" title="数量" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input-number
                            class="salecounts-input-cell"
                            style="width: 100%"
                            type="number"
                            ref="countRef"
                            :min="1"
                            :precision="0"
                            controls-position="right"
                            size="small"
                            v-model="scope.row.Count"
                            :disabled="type == 1"
                            @change="priceChange"
                            @keyup.enter.native="keyEvent($event, 'Count')"
                            @keyup.right.native="keyEvent($event, 'Count')"
                            @keyup.left.native="keyEvent($event, 'Count')"
                            @focus="selectAutoHandle('countRef')"
                        ></el-input-number>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.Unit }]" @click="focusHandle('unitSelect')">{{ row.Unit }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select
                            ref="unitSelect"
                            default-first-option
                            size="small"
                            v-model="scope.row.Unit"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="单位"
                            @visible-change="unitVisibleChange($event)"
                            :disabled="type == 1"
                            popper-class="el-select-style-gray"
                        >
                            <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="jhj" title="报价价格" width="130" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': row.MarketPrice === 0 }]">{{ row.MarketPrice }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input-number
                            class="sales-input-cell"
                            ref="marketPirceRef"
                            :min="0"
                            :precision="2"
                            :step="0.01"
                            controls-position="right"
                            size="small"
                            v-model="scope.row.MarketPrice"
                            :disabled="type == 1"
                            @keyup.enter.native="addItem(true)"
                            @keyup.left.native="keyEvent($event, 'MarketPrice')"
                            @keyup.right.native="keyEvent($event, 'MarketPrice')"
                            @focus="selectAutoHandle('marketPirceRef')"
                        ></el-input-number>
                    </template>
                </ux-table-column>
                <ux-table-column field="cgzj" title="总价格" width="160" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 div-margin-op">
                            <img
                                src="@/assets/images/sup.png"
                                title="采购历史"
                                style="width: 27px; height: 27px"
                                v-if="row.EntpTempGoodsId"
                                @click="showHistories(row.EntpTempGoodsId)"
                            />
                            <img
                                src="@/assets/images/cus.png"
                                style="width: 26px; height: 26px; margin-right: 4px"
                                title="销售历史"
                                v-if="row.EntpTempGoodsId"
                                @click="showSaleStat(row)"
                            />
                            <img
                                src="@/assets/images/analysis.png"
                                style="width: 23px; height: 23px; margin-right: 4px"
                                title="数据分析"
                                v-if="row.EntpTempGoodsId"
                                @click="analysis(row)"
                            />
                            <span>
                                {{ row.MarketPrice * row.Count ? (row.MarketPrice * row.Count).toFixed(2) : 0 }}
                            </span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="ly" title="留余" width="80" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                {{ isAddWaitIn ? '留余=总库存数－总待出数＋总待入数' : '留余=总库存数－总待出数' }}
                                <br />注意：此处已统计退货商品的数量
                                <br />
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <el-tooltip
                                effect="dark"
                                :content="
                                    '待入仓(' +
                                        row.POrderWaitInQuantity +
                                        '）  待出仓(' +
                                        row.OrderWaitOutQuantity +
                                        '）  库存(' +
                                        (submitData.WarehouseId ? row.StorageInventory : row.Inventory) +
                                        '）'
                                "
                                placement="top"
                            >
                                <span
                                    :class="{
                                        'color-red':
                                            (submitData.WarehouseId ? row.StorageInventory : row.Inventory) +
                                                (isAddWaitIn ? row.POrderWaitInQuantity : 0) -
                                                row.OrderWaitOutQuantity <=
                                            0
                                    }"
                                >
                                    {{ (submitData.WarehouseId ? row.StorageInventory : row.Inventory) + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity }}
                                </span>
                            </el-tooltip>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="bz" title="备注" width="180" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Remark }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input
                            ref="remarkRef"
                            class="remark-input-cell"
                            size="small"
                            v-model="scope.row.Remark"
                            :disabled="type == 1"
                            @keyup.enter.native="addItem(true)"
                            @keyup.left.native="keyEvent($event, 'Remark')"
                        ></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate" v-if="type != 1">
                            <el-button size="small" @click="delItem(rowIndex)" icon="el-icon-delete" v-if="dataList.length !== 1"></el-button>
                            <el-button size="small" type="primary" @click="addItem(true)" icon="el-icon-plus" v-if="rowIndex + 1 === dataList.length"></el-button>
                            <el-button
                                size="small"
                                @click="upLock(rowIndex)"
                                :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex"
                            ></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
            <div class="bottom-div" v-if="type != 1 && permission.submit" @click="hideMsg">
                <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm()" :disabled="!canRequest">{{ permission.submit }}</el-button>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑供应商' : '新增供应商'" :visible.sync="dialogVisible" width="1000px">
            <div class="dialog-content" v-if="dialogVisible">
                <customerEdit ref="customerEdit" :type="customerEditType" :cusId="submitData.EntpCusId" source="2" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px" v-dialog-drag :modal="false" lock-scroll id="search-dialog">
            <div v-if="searchVisible">
                <searchAP
                    :dragType="1"
                    dragSign="supplierRFQEdit"
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="submitData.EntpCusName"
                    :SelectedData="selectedData"
                    :Source="1"
                    :StorageId="submitData.WarehouseId"
                    @chooseAllAPsHandle="chooseAllAPsHandle"
                    @closeDialog="closeSearchDialog"
                ></searchAP>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!-- 新增库存 -->
        <transInventory v-if="addAPVisible" :dialogFormVisible="addAPVisible" :apParams="addAPParams" @closeDialog="closeAddAPDialog"></transInventory>
        <!--    采购历史    -->
        <el-dialog :close-on-click-modal="false" title="采购历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APPurchaseHistory
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusId="submitData.EntpCusId"
                    :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog :title="SaleDialogTitle" :close-on-click-modal="false" :visible.sync="eyeHistoryVisible" append-to-body width="1200px">
            <div v-if="eyeHistoryVisible">
                <APHistory :showCusColumn="false" :EntpTempGoodsId="APId" @closeDialog="eyeHistoryVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis :GoodsId="APId" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import customerEdit from '@/components/business/customerManage/customerEdit';
import searchAP from '@/components/common/searchAP';
import APMsg from '@/components/common/APMsg';
import transInventory from '@/components/business/search/transInventory';
import APPurchaseHistory from '@/components/common/APPurchaseHistory';
import APHistory from '@/components/common/APHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        searchAP,
        APMsg,
        breadcrumb,
        transInventory,
        APPurchaseHistory,
        APHistory,
        goodsAnalysis
    },
    data() {
        return {
            isCheckCode: true,
            needConfirm: true,
            customerEditType: 1,
            APMsgVisible: false,
            searchVisible: false,
            dialogVisible: false,
            showOrderMsg: true,
            EntpTempGoodsIdEdit: '',
            canRequest: true,
            historyStyle: {
                top: ''
            },
            editIndex: -1,
            showHistory: false,
            historyNoData: true,
            loading: false,
            submitData: {
                InquiryId: '',
                EntpCusId: '',
                NeedTime: '',
                Remark: '',
                ITime: '',
                QTime: '',
                PriceSumShip: '',
                IsSubmitReview: false,
                WarehouseId: '',
                DetailList: [],
                OId: '' // 采购退货单id，转询价使用
            },
            Limit: 10,
            download_url: this.$util.QN_URL_BASE,
            customerList: [],
            codeList: [],
            nameList: [],
            seriesList: [],
            dataList: [],
            historyList: [],
            unitList: [],
            type: 1, //  1 查看 2 编辑 3 新增 4 从库存配件管理过来的
            id: '',
            pageTitle: '',
            rules: {
                EntpCusId: [{ required: true, message: '请选择客户', trigger: 'blur' }]
            },
            permission: {},
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            apcodeSource: null, // 用于处理取消编码请求操作
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            // 用于供应商列表，分页搜索功能
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于配件名称列表，分页搜索功能
            nameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于车型列表，分页搜索功能
            autoSerieForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: false,
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            // 功能配置项：初始数量值
            initNumber: 1,
            isAddWaitIn: true,
            // 新增库存
            addAPVisible: false,
            addAPParams: {},
            eyeHistoryVisible: false,
            goodsAnalysisVisible: false,
            historyVisible: false,
            allNum: 1,
            allMoney: 0,
            SaleDialogTitle: '',
            changeCodeConfig: false,
            warehouseList: [], //仓库地址
            warehouseType: '',
            isInvenShow: false,
            isOriginShow:false,//产地
            isSizeShow:false,//规格  
            isShowBrand:false,//是否显示品牌
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getConfigByCodes();
    },
    mounted() {
        window.onclick = () => {
            this.showHistory = false;
        };
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);

        this.permission = this.$util.getPermission('supplierRFQ');
        this.id = this.$route.query.id;
        this.submitData.InquiryId = this.$route.query.id;
        this.type = this.$route.query.type;
        let purxjOrder = this.$util.getLocalStorage('purxjOrder');
        let datalist = this.$util.getLocalStorage('purxjOrder_dataList');          
        if (this.type == 1) {
            this.pageTitle = '查看询价单';
            this.getBJOrder();
                       
        } else if (this.type == 2) {
            this.pageTitle = '编辑询价单';
            if (purxjOrder && datalist && datalist.length > 0){
                this.getDataFromChace();
            }else{
                this.getBJOrder();
            }           
        } else if (this.type == 3) {
            this.pageTitle = '新增询价单';
            if (purxjOrder && datalist && datalist.length > 0){
                this.getDataFromChace();
            } else{
                this.getdefaultWarehouses();
                this.addItem(false);
            }            

        } else if (this.type == 4) {
            this.pageTitle = '再次询价单'; //采购转询价
            if (purxjOrder && datalist && datalist.length > 0){
                this.getDataFromChace();
            } else{
                this.bjAgain();
            }             
        } else if (this.type == 6) {
            this.pageTitle = '采购退货转询价';
            if (purxjOrder && datalist && datalist.length > 0){
                this.getDataFromChace();
            } else{
                this.submitData.OId = this.$route.query.rid;
                this.getPurRetrunOrder();
            }  
        }

        setTimeout(() => {
            this.resetHeight();
        }, 0);
        window.onresize = () => {
            this.resetHeight();
        };
    },
    computed: {
        // 列表高度
        infiniteTableHeight() {
            let bottomHeight = this.type == 1 ? 24 : 78;
            return this.infiniteListHeight - bottomHeight;
        },
        // 是否加锁
        isLock() {
            return this.hasLock && [2, 3, 4].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        }
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            if (key === 107 || key === 187) {
               if (!this.searchVisible) this.addItem(true);
            }
            if (key == 113) {
                this.searchVisible = true;
            }
        },
        getConfigByCodes() {
            let codes = ['ddhhm', 'kdyjz', 'kdbjsd', 'spmrsl', 'lybsdr', 'ddkcs','kdspcd','kdspgg','kdxspp','xzqpbmdwyx'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        let rValue = data[i].RValue;
                        switch (code) {
                            case 'ddhhm': //是否展示互换码
                                this.changeCodeConfig = result;
                                break;
                            case 'kdyjz': // 获取预加载商品数据的功能设置结果
                                this.isPreloadApCodeList = result;
                                break;
                            case 'kdbjsd': // 选择商品完成回车或点加号后触发锁定不可修改
                                this.hasLock = result;
                                break;
                            case 'spmrsl': // 获取客户配置的初始数量值
                                if (result && !isNaN(rValue)) this.initNumber = rValue;
                                if (this.dataList && this.dataList.length > 0) {
                                    let lastData = this.dataList[this.dataList.length - 1];
                                    if (!lastData.EntpTempGoodsId) {
                                        lastData.Count = this.initNumber;
                                    }
                                }
                                break;
                            case 'lybsdr': //获取留余的计算方式
                                this.isAddWaitIn = !result;
                                break;
                            case 'ddkcs':
                                this.isInvenShow = result;
                                break;
                            case 'kdspcd': //是否出现产地
                                this.isOriginShow = result;
                                break; 
                            case 'kdspgg': //是否出现规格
                                this.isSizeShow = result;
                                break;    
                            case 'kdxspp': //是否显示品牌
                                this.isShowBrand = result;
                                break;        
                            case 'xzqpbmdwyx': //是否检测编码重复
                                this.isCheckCode = result;
                                break;                                                        
                        }
                    }
                }
            });
        },

        // 关闭新增库存弹框
        async closeAddAPDialog(result, row) {
            this.addAPVisible = false;
            if (!row) return;
            this.$set(this.dataList, this.addAPParams.index, {
                ...row,
                Count: this.initNumber,
                State: 0,
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                MarketPrice: row.CostPrice // 供应商报价对应成本价
            });
            this.addPageChace()
        },

        // 计算infinite-list高度
        resetHeight() {
            let listObj = document.getElementById('infinite-list');
            if (!listObj) return;
            let clientObj = listObj.getBoundingClientRect();
            this.infiniteListHeight = window.innerHeight - clientObj.top - 10;
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        // 搜索
        showSearch() {
            if (this.dataList.length > 0) {
                this.selectedData = [];
                this.dataList.forEach(item => {
                    if (item.EntpTempGoodsId) this.selectedData.push(item.EntpTempGoodsId);
                });
            }
            this.searchVisible = true;
        },
        // 搜索配件弹框 - 确认筛选结果按钮操作
        chooseAllAPsHandle(data) {
            data.searchData.CheckSalesOutWHCout = false;
            this.searchVisible = false;
            this.searchApParams = {
                ...data.searchData,
                limit: this.searchApParams._limit,
                _visible: true,
                _percentage: 0,
                _limit: this.searchApParams._limit,
                _totalCount: data.searchData.limit
            };
            this.loopSearch();
        },
        // 开始循环
        async loopSearch() {
            const { data } = await this.$util.axiosPost({
                url: '/api/EntpGoods/GetFullDataGoodsListForOrder',
                data: this.searchApParams,
                hideLoading: true
            });
            this.searchApParams._percentage = parseInt(((this.searchApParams.page * this.searchApParams.limit) / this.searchApParams._totalCount) * 100);
            this.searchApParams.page += 1;
            //最后的条件判断，防止和弹窗接口不一致导致页面崩溃
            let _stop = !data || data.length < this.searchApParams._limit||data.length>=this.searchApParams._totalCount;
            this.closeSearchDialog(data);
            if (_stop) {
                this.searchApParams._percentage = 100;
                this.searchApParams._visible = false;
            } else {
                this.loopSearch();
            }
        },
        closeSearchDialog(items, noClose = false) {
            let that = this;
            let itemList = [...items];
            if (itemList.length == 0) {
                if (!noClose) {
                    that.searchVisible = false;
                    return;
                }
            }
            let newGoodsList = [];
            for (let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                let goodsIdx = that.dataList.findIndex(e => item.APCode == e.APCode);
                if (goodsIdx === -1) {
                    let newGoods = {
                        EntpTempGoodsId: item.EntpTempGoodsId,
                        APCode: item.APCode,
                        GoodName: item.GoodName,
                        AutoSerise: item.AutoSerise,
                        Count: this.initNumber,
                        Unit: item.Unit,
                        Remark: item.Remark,
                        State: 0,
                        MarketPrice: item.LatestPurPrice ? item.LatestPurPrice : item.CostPrice,
                        Inventory: item.Inventory,
                        OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                        POrderWaitInQuantity: item.POrderWaitInQuantity,
                        StorageInventory: item.StorageInventory,
                        Size: item.Size,
                        Origin: item.Origin,
                        Brand: item.Brand,
                    };
                    if (!isNaN(item._count)) {
                        newGoods.Count = item._count;
                    }
                    if (!isNaN(item._price)) {
                        newGoods.MarketPrice = item._price;
                    }
                    newGoodsList.push(newGoods);
                } else {
                    // 重复数据并且从搜索配件双击回来时修改数量和销售价
                    if (noClose) {
                        that.dataList[goodsIdx].Count = item._count;
                        that.dataList[goodsIdx].MarketPrice = item._price;
                    }
                }
            }
            //判断最后一条数据是否空值，是的话移到最后
            if (that.dataList.length == 0) {
                that.dataList = that.dataList.concat(newGoodsList);
            } else {
                let lastItem = that.dataList[that.dataList.length - 1];
                if (!lastItem.APCode && !lastItem.GoodName) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                    that.dataList = that.dataList.concat(newGoodsList);
                    that.dataList.push(lastItem);
                } else {
                    that.dataList = that.dataList.concat(newGoodsList);
                }
            }
            // that.priceChange();
            that.addPageChace();
            if (!noClose) {
                that.searchVisible = false;
            }
            that.$nextTick(() => {
                if (that.$refs[`countRef`]) {
                    that.$refs[`countRef`][0].focus();
                }
            });
        },
        // 配件信息
        hideMsg() {
            this.showOrderMsg = false;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        showMsg() {
            this.showOrderMsg = true;
            setTimeout(() => {
                this.resetHeight();
            }, 100);
        },
        // 配件信息
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
        },
        closeDialog(edit) {
            this.dialogVisible = false;
            if (edit) {
                this.searchCustomer();
            }
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogVisible = true;
        },
        //采购转询价
        bjAgain() {
            this.$util
                .axiosGet({
                    url: '/api/EntpPurchaseOrder/GetEntpInqPurchaseOrder',
                    data: {
                        EntpCusPOId: this.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    data.EntpCusOId = this.id;
                    data.DetailList.forEach(ele => {
                        ele.hasLock = this.hasLock;
                    });
                    this.submitData = data;
                    this.customerList.push({
                        EntpCusId: res.data.EntpCusId,
                        EntpCusName: res.data.EntpCusName
                    });
                    this.dataList = res.data.DetailList;
                    // this.priceChange();
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                });
        },
        // 获取询价单详情
        getBJOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetEntpSupInquiryOrder',
                    data: {
                        InquiryId: this.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    data.InquiryId = this.id;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });
                    this.submitData = data;
                    data.DetailList.forEach(ele => {
                        ele.hasLock = this.hasLock;
                    });
                    this.dataList = data.DetailList;
                    // this.priceChange();
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                });
        },
        //获取退货转报价单的数据
        getPurRetrunOrder() {
            this.$util
                .axiosGet({
                    url: '/api/EntpPurReturnOrder/GetOrderforInquiry',
                    data: {
                        PReturnId: this.submitData.OId
                    }
                })
                .then(res => {
                    let data = res.data;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });
                    this.submitData = data;
                    if (data.Warehouse) {
                        this.warehouseList.push({
                            WarehouseId: data.Warehouse.WarehouseId,
                            WarehouseName: data.Warehouse.WarehouseName,
                            Type: data.Warehouse.WarehouseType
                        });
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                    if (data.DetailList && data.DetailList.length > 0) {
                        data.DetailList.forEach(ele => {
                            ele.hasLock = this.hasLock;
                        });
                        this.dataList = data.DetailList;
                    } else {
                        this.addItem(false);
                    }
                });
        },
        // 提交询价单
        submitForm() {
            let _dataList = this.dataList;
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择供应商');
                return;
            }
            if (this.submitData.PriceSumShip < 0) {
                this.$util.warningMsg('运费不能小于0');
                return;
            }
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (_dataList[i].State != 0) {
                    this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (_dataList[i].MarketPrice == '' || Number(_dataList[i].MarketPrice) <= 0) {
                    this.$util.warningMsg('请填写正确的供应商报价');
                    return;
                }
            }
            this.submitData.DetailList = _dataList;
            if (!this.canRequest) {
                return;
            }
            let checkRepeat = this.checkRepeatAndReturnData();
            if (checkRepeat.hasRepeat) {
                this.$confirm('订单含有重复商品项，是否需要累加', '', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        // 覆盖数据
                        this.dataList = checkRepeat.row;
                        this.submitData.DetailList = checkRepeat.row;
                        this.submitFormAgain();
                    })
                    .catch(() => {});
            } else {
                this.submitFormAgain();
            }
        },
        submitFormAgain() {
            this.canRequest = false;
            let url = '/api/EntpInquiryOrder/SaveEntpInquiryOrder';
            if (+this.type == 6) url = '/api/EntpInquiryOrder/TransformPurReturnOrder';
            this.$util
                .axiosPost({
                    url: url,
                    data: this.submitData
                })
                .then(() => {
                    this.needConfirm = false;
                    this.$util.successMsg('提交询价单成功');
                    //编辑后列表页面需要刷新
                    this.$store.commit('updateNeedRefresh', true);
                    setTimeout(() => {
                        this.canRequest = true;
                        this.$router.push('/purchaseManage/inquirySheet');
                    }, 2000);
                })
                .catch(() => {
                    this.canRequest = true;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            if(this.isCheckCode){
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                         row.push(Object.assign({}, item));
                    }
                });
            }
            else{
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
            this.addPageChace();
        },
        // 添加一行
        addItem(addPageChace) {
            let that = this;
            let _dataList = that.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    that.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    that.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    that.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    that.$util.warningMsg('请填写单位');
                    return;
                }
            }

            // 上锁
            if (that.isLock) {
                that.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }
            if (addPageChace) {
                that.addPageChace(); //添加销售订单缓存
            }
            that.dataList.push({
                IsNew: false,
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                Count: that.initNumber,
                MarketPrice: '',
                Unit: '',
                Remark: '',
                State: 0,
                Inventory: 0, //商品总数量
                StorageInventory: 0, //仓库库存数量
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                Origin:"",
                Size:"",
                Brand:""
            });

            setTimeout(() => {
                that.$refs.infiniteTable.scrollToRow(that.dataList[that.dataList.length - 1]);
                that.$refs.infiniteTable.setActiveRow(that.dataList[that.dataList.length - 1]);
                if (that.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);
            that.$nextTick(() => {
                setTimeout(function() {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(type) {
            if (type === 'sapcode') {
                setTimeout(() => {
                    this.$refs[`sapcode`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect') {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect') {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'originRef') {
                setTimeout(() => {
                    this.$refs[`originRef`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            this.$refs[ref].select();
        },
        // 搜索顾客
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.customerList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.loading = true;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.customerList = this.$util.uniqueArr(this.customerList, data);
                //修改客户时要更新页面上展现的名称
                if (this.customerList.length > 0) {
                    let currCust = this.customerList.find(e => e.EntpCusId == this.EntpCusId);
                    if (currCust) {
                        this.submitData.EntpCusName = currCust.EntpCusName;
                    }
                }
            });
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchCustomer();
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        customerChange(value) {
            let that = this;
            if (!value) {
                that.submitData.EntpCusName = '';
            } else {
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                }
            }
        },
        // 改变商品数量
        handleNumChange(data, value, index) {
            this.dataList[index].Count = value;
        },
        // 搜索汽配编码
        async searchCode(key) {
            // 取消请求
            if (this.apcodeSource) {
                this.apcodeSource.cancel();
            }
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeList = [];
            }
            if (this.codeForm.stopLoad) return;
            this.loading = true;
            // 初始化对象
            this.apcodeSource = this.axios.CancelToken.source();
            const { data } = await this.$util.axiosGet({
                url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                data: {
                    SId: this.submitData.WarehouseId,
                    APCode: this.codeForm.key,
                    Page: this.codeForm.Page,
                    Limit: this.codeForm.Limit
                },
                hideLoading: true,
                cancelToken: this.apcodeSource.token // 取消操作标识
            });
            this.loading = false;
            if (!data) return;
            this.codeForm.stopLoad = data.length < this.codeForm.Limit;
            this.codeList = this.$util.uniqueArr(this.codeList, data);
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        // 搜索名称
        searchName(key) {
            if (![undefined].includes(key)) {
                this.nameForm.Page = 1;
                this.nameForm.stopLoad = false;
                this.nameForm.key = key;
                this.nameList = [];
            }
            if (this.nameForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        SId: this.submitData.WarehouseId,
                        GoodName: this.nameForm.key,
                        Page: this.nameForm.Page,
                        Limit: this.nameForm.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    if (!res.data) return;
                    this.nameForm.stopLoad = res.data.length < this.nameForm.Limit;
                    this.nameList = this.$util.uniqueArr(this.nameList, res.data);
                });
        },
        // 汽配名称列表，加载更多
        searchNameLoad() {
            this.nameForm.Page += 1;
            this.searchName();
        },
        //当汽配件名称下拉框出现时触发
        apNameVisibleChange(event) {
            let that = this;
            if (event && that.nameList.length == 0 && that.isPreloadApCodeList) {
                that.searchName('');
            }
        },
        // 搜车系
        searchAutoSerie(key) {
            if (![undefined].includes(key)) {
                this.autoSerieForm.Page = 1;
                this.autoSerieForm.stopLoad = false;
                this.autoSerieForm.key = key;
                this.seriesList = [];
            }
            if (this.autoSerieForm.stopLoad) return;
            this.loading = true;
            this.$util.searchAutoSerie(this.autoSerieForm.key, this.autoSerieForm.Page, this.autoSerieForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.autoSerieForm.stopLoad = data.length < this.autoSerieForm.Limit;
                this.seriesList = this.$util.uniqueArr(this.seriesList, data);
            });
        },
        // 车系列表，加载更多
        searchAutoSerieLoad() {
            this.autoSerieForm.Page += 1;
            this.searchAutoSerie();
        },
        //当车系下拉框出现时触发
        autoSerieVisibleChange(event) {
            let that = this;
            if (event && that.seriesList.length == 0 && that.isPreloadApCodeList) {
                that.searchAutoSerie('');
            }
        },
        // 名称改变
        nameChange(value, index) {
            this.editIndex = index;
            let _list = this.nameList;
            for (let i = 0; i < _list.length; i++) {
                if (_list[i].GoodName == value) {
                    this.dataList[index].MarketPrice = _list[i].CostPrice;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].State = 0;
                    if (!this.dataList[index].APCode) {
                        this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                        this.dataList[index].APCode = _list[i].APCode;
                    }

                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;
                    this.dataList[index].Origin = _list[i].Origin;
                    this.dataList[index].Size = _list[i].Size;
                    this.dataList[index].Brand = _list[i].Brand;
                    this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, '', this.submitData.EntpCusId, '3', false).then(data => {
                        if (data) {
                            this.dataList[index].MarketPrice = data.LatestPurPrice > 0 ? data.LatestPurPrice : '';
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                        }
                    });
                    break;
                }
            }
        },
        // 编码改变
        codeChange(value, index) {
            let isNew = true;
            this.editIndex = index;
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
            }
            for (let i = 0; i < _list.length; i++) {
                let checkItem = this.isCheckCode ? _list[i].APCode:_list[i].EntpTempGoodsId;
                if (checkItem == value) {
                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].MarketPrice = _list[i].CostPrice;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].IsNew = false;
                    this.dataList[index].State = 0;
                    this.dataList[index].Inventory = _list[i].Inventory;
                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;
                    this.dataList[index].Origin = _list[i].Origin;
                    this.dataList[index].Size = _list[i].Size;    
                    this.dataList[index].Brand = _list[i].Brand;               
                    isNew = false;
                    this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, '', this.submitData.EntpCusId, '3', false).then(data => {
                        if (data) {
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                            this.dataList[index].MarketPrice = data.LatestPurPrice > 0 ? data.LatestPurPrice : '';
                        }
                    });
                    break;
                }
            }
            if (isNew && value && this.isCheckCode) {
                let that = this;
                this.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].MarketPrice = 0;
                        that.dataList[index].IsNew = true;
                        that.dataList[index].State = 0;
                        that.dataList[index].Origin="";
                        that.dataList[index].Size="";
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                } else {
                                    that.addAPParams = {
                                        APCode: that.dataList[index].APCode,
                                        index: index
                                    };
                                    that.addAPVisible = true;
                                    if (that.$refs[`code${index}`]) {
                                        that.$refs[`code${index}`].blur();
                                    }
                                }
                            });
                    }
                });
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if(this.isCheckCode)
                rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else
                rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        // 历史销售
        showHistories(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog() {
            this.historyVisible = false;
        },
        showSaleStat(row) {
            if (row) {
                this.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodName + ' ' + row.AutoSerise;
                this.APId = row.EntpTempGoodsId;
                this.eyeHistoryVisible = true;
            }
        },
        analysis(row) {
            if (row) {
                this.APId = row.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        // 设置展示合计数据行
        setSummaries(param) {
            const { data } = param;
            let num = 0;
            let price = 0;
            data.forEach(ele => {
                num += Number(ele.Count);
                price += Number(ele.Count * ele.MarketPrice ? (ele.Count * ele.MarketPrice).toFixed(3) : 0);
            });
            var countColIndex=0;
            var sumColIndex=0;
            countColIndex=param.columns.findIndex(item=>{ return item.title == '数量'});
            sumColIndex=param.columns.findIndex(item=>{ return item.title == '报价价格'});

            var arr=new Array(param.columns.length);
            if(countColIndex!=-1){
                arr[countColIndex]=num;
                 arr[countColIndex-1]="总数量";
            }
            if(sumColIndex!=-1){
                arr[sumColIndex]=price.toFixed(2);
                arr[sumColIndex-1]="合计";
            }
            return [arr];                       
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].MarketPrice ? (DetailList[i].Count * DetailList[i].MarketPrice).toFixed(3) : 0);
            }
            this.allMoney = _allMoney;
            this.allNum = _allNum;
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) {
                    that.$util.getWarehouse(1).then(data => {
                        that.warehouseList = data;
                    });
                }
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        // that.submitData.WarehouseAddr = that.warehouseList[i].Address;
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;
                        break;
                    }
                }

                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: val,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.StorageInventory = getStorage.Count;
                                        e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                    }
                                });
                            })
                            .catch(() => {});
                    }
                }
            }
        },
        //从缓存中获取默认出仓仓库
        getdefaultWarehouses() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetLatestInquiryOrderWarehouse',
                    hideLoading: true
                })
                .then(res => {
                    let defaultWareshouse = res.data;
                    if (defaultWareshouse) {
                        this.warehouseList.push({
                            WarehouseId: defaultWareshouse.WarehouseId,
                            WarehouseName: defaultWareshouse.WarehouseName,
                            Address: defaultWareshouse.Address
                        });
                        this.$set(this.submitData, 'WarehouseId', defaultWareshouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', defaultWareshouse.WarehouseName);
                        this.$set(this.submitData, 'WarehouseAddr', defaultWareshouse.Address);
                        this.warehouseType = defaultWareshouse.WarehouseType;
                    }
                });
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'Enter') {
                if (code == 'Count' || code == 'MarketPrice') {
                    that.addItem();
                } else {
                    let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
                    inputAll[0].focus();
                }
            } else if (ev.key == 'ArrowLeft') {
                if (code == 'Count') {
                    // let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    // inputAll[2].focus();
                    if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                    else that.$refs[`partsNameSelect`].focus();                    
                } else if (code == 'MarketPrice') {
                    let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'AutoSerise') {
                    that.$refs[`autoSeriseSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[1].focus();
                } else if (code == 'Remark') {
                    that.$refs[`remarkRef`].blur();
                    let inputAll = document.querySelectorAll('.sales-input-cell .el-input__inner');
                    inputAll[0].focus();
                }else if (code == 'Origin'){
                     that.$refs[`autoSeriseSelect`].focus();
                }
            } else if (ev.key == 'ArrowRight') {
                if (code == 'Count') {
                    let inputAll = document.querySelectorAll('.sales-input-cell .el-input__inner');
                    inputAll[0].focus();
                } else if (code == 'APCode') {
                    that.$refs[`sapcode`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[1].focus();
                } else if (code == 'GoodName') {
                    that.$refs[`partsNameSelect`].blur();
                    let inputAll = document.querySelectorAll('.elx-cell .el-select .el-input__inner');
                    inputAll[2].focus();
                } else if (code == 'AutoSerise') {
                    // that.$refs[`autoSeriseSelect`].blur();
                    // let inputAll = document.querySelectorAll('.salecounts-input-cell .el-input__inner');
                    // inputAll[0].focus();
                    if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                    else that.$refs[`countRef`].focus();                       
                } else if (code == 'MarketPrice') {
                    let inputAll = document.querySelectorAll('.remark-input-cell .el-input__inner');
                    inputAll[0].focus();
                }else if (code == 'Origin'){
                    that.$refs[`countRef`].focus(); 
                }
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage('purxjOrder', this.submitData);
            this.$util.setLocalStorage('purxjOrder_dataList', this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage('purxjOrder');
            this.$util.clearLocalStorage('purxjOrder_dataList');
        },        
        //从缓存中读取数据
        getDataFromChace(){
            let xjModel = this.$util.getLocalStorage('purxjOrder');
            let datalist = this.$util.getLocalStorage('purxjOrder_dataList');
            if(xjModel){
                this.submitData = xjModel;
                let isexit = this.customerList.find(e => e.EntpCusId == xjModel.EntpCusId);
                if (!isexit) {
                    this.customerList.push({
                        EntpCusId: xjModel.EntpCusId,
                        EntpCusName: xjModel.EntpCusName
                    });                
                }
            }
            if (xjModel.WarehouseId) {
                this.warehouseList.push({
                    WarehouseId: xjModel.WarehouseId,
                    WarehouseName: xjModel.WarehouseName,
                    Type:xjModel.WarehouseType
                });
                this.warehouseType = xjModel.WarehouseType;
                this.$set(this.submitData, 'WarehouseId', xjModel.WarehouseId);
                this.$set(this.submitData, 'WarehouseType', xjModel.WarehouseType);
                this.$set(this.submitData, 'WarehouseName', xjModel.WarehouseName);
            }else{
                this.getdefaultWarehouses();
            }             
            this.dataList = datalist;            
        },        
    }
};
</script>
<style lang="less" scoped>
.el-row {
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 10px;
    }
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 36px;
    line-height: 36px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }

    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.btn-ctn {
    padding: 30px 0;
    margin-right: 110px;
    text-align: right;
    // padding-bottom: 240px;
}
.add-btn {
    position: absolute;
    right: -40px;
    bottom: -40px;
}
.less-btn {
    position: absolute;
    right: -40px;
    top: 4px;
    z-index: 2;
}
.table-main {
    position: relative;
}
.image-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    border: 1px dashed @border3Color;
}
.table-title {
    line-height: 36px;
    text-align: center;
    font-weight: bold;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.table-item {
    height: 50px;
    position: relative;
}
.div-table-row {
    overflow: inherit;
    margin-left: 0;
}
.div-table-cell-code {
    position: relative;
    .row-delete {
        position: absolute;
        padding: 1px 6px;
        top: 0;
        right: 0;
        color: #fff;
        background: #ffcc66;
        border-radius: 12.5px;
    }
}
.history-main {
    position: absolute;
    left: 0;
    width: 100%;
    height: 140px;
    overflow: auto;
    padding: 10px;
    border: 1px solid @border3Color;
    background: white;
    z-index: 2;
    .history-row {
        display: flex;
        align-items: center;
        cursor: pointer;
        &:hover {
            background: @border3Color;
        }
        > div {
            text-align: center;
            line-height: 30px;
        }
    }
}
.history-no-data {
    text-align: center;
    font-size: 26px;
    line-height: 100px;
}
.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}
</style>
<style lang="less">
.inquiry-order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }
    .el-dialog__body {
        overflow: auto;
    }
}
#search-dialog::-webkit-scrollbar {
    display: none;
}
.supplier-req-edit {
     #search-dialog {
        margin-right: 35px;
    }
    .elx-table {
        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }
        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }
                .div-padding-12 {
                    padding: 4px 12px 0;
                }
                .operate {
                    padding: 0 12px;
                }
                .text-btn {
                    button {
                        padding-left: 0;
                        padding-right: 0;
                    }
                }
                td {
                    height: 26px;
                }
            }
            .elx-cell {
                padding: 0;
                height: 32px;
            }
            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }
        .elx-table--footer-wrapper {
            margin-top: 0 !important;
            .elx-footer--row {
                .elx-footer--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }
        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }
    .sales-input-cell {
        .el-input-number {
            width: 100%;
        }
        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }
        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }
    .info-icon {
        vertical-align: top;
        margin-top: 2px;
        margin-right: 5px;
    }
    .bottom-div {
        margin-top: 14px;
        text-align: right;
    }
    .special-border {
        height: 100%;
        border-radius: 3px;
        border: 1px solid #ffcc00;
    }
    .sales-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }
    }
}
</style>
